<template>
  <unroll-element
    :title="stringified_dict(metavariables_poid)"
    :available="full_cv_instantiated"
    :start_opened="full_cv_instantiated"
  >
    <div v-if="full_cv_instantiated">
      <div v-if="!_.isEmpty(caruana_full_cv)">
        <performances-chart-caruana
          key="full_cv_caruana_chart"
          :project_id="project_id"
          :is_caruana="true"
          :is_cv="true"
          :is_single_cv="false"
          :tracking_infos="caruana_full_cv"
          :nb_iters="nb_full_cv_iters"
        />
        <performances-table-caruana
          key="full_cv_caruana_table"
          :project_id="project_id"
          :is_caruana="true"
          :is_cv="true"
          :is_single_cv="false"
          :tracking_infos="caruana_full_cv"
          :models="models"
        />
      </div>
      <div v-else>
        <performances-chart-caruana
          key="full_cv_simple_chart"
          :project_id="project_id"
          :is_caruana="false"
          :is_cv="true"
          :is_single_cv="false"
          :tracking_infos="tracking_full_cv"
          :nb_iters="nb_full_cv_iters"
        />

        <performances-table-caruana
          key="full_cv_simple_table"
          :project_id="project_id"
          :is_caruana="false"
          :is_cv="true"
          :is_single_cv="false"
          :tracking_infos="tracking_full_cv"
          :model_name="models[0]"
        />
      </div>
    </div>
  </unroll-element>
</template>

<script>
import _ from 'lodash'

import {
  brick_mixin,
  subscription_mixin,
  metavariables_tracking_info_mixin,
  brick_generic_modelgenerator_tracking_info_mixin,
} from '@/components/mixin.js'

import UnrollElement from './unroll_element.vue'
import PerformancesChartCaruana from './performances_chart_caruana.vue'
import PerformancesTableCaruana from './performances_table_caruana.vue'

// *****************************************************************************

export default {
  name: 'BrickGenericModelgeneratorSubcomponentFullCv',
  components: {
    UnrollElement,
    PerformancesChartCaruana,
    PerformancesTableCaruana,
  },

  mixins: [
    brick_mixin,
    subscription_mixin,
    metavariables_tracking_info_mixin,
    brick_generic_modelgenerator_tracking_info_mixin,
  ],
  props: ['brick_id', 'project_id', 'metavariables_poid', 'nb_full_cv_iters'],
  data() {
    return {}
  },

  computed: {
    _() {
      return _
    },

    caruana_full_cv() {
      let res = {}
      _.forEach(_.entries(this.caruana_model_searches), ([name, info]) => {
        res[name] = this.fetch_poid_tracking_info(
          `caruana_full_cv_${name}_${info}`,
          (info || {}).full_cv
        )
      })
      return res
    },
    tracking_full_cv() {
      return this.model_tracking_info.full_cv
    },

    full_cv_instantiated() {
      let res =
        !_.isEmpty(this.caruana_full_cv) ||
        !_.isUndefined(this.tracking_full_cv)
      return res
    },
  },

  watch: {
    full_cv_instantiated: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          if (nv) {
            this.$emit('is_instantiated')
          }
        }
      },
    },
  },
}
</script>
